module.exports = {
    API_KEY : "d42a0d190464a2be90977c3996382811",
   
    // API_K_WINN_URL  : "https://app.k-winn.com/v1/crm/",
    // K_WINN_URL  : "https://app.k-winn.com/",
    
    API_K_WINN_URL  : "https://stagingapi.k-winn.com/v1/crm/",
    K_WINN_URL  : "https://stagingapi.k-winn.com/",

}